import type { CreateDeliveryProposalFormSchemaType } from "@/pages/admin-delivery-proposal-create/model/validation";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import {
  AccordionDetails,
  Autocomplete,
  CircularProgress,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import { type Control, Controller } from "react-hook-form";

export const CompanyForm = ({
  control,
  companies,
}: {
  control: Control<CreateDeliveryProposalFormSchemaType>;
  companies: FreightMatching.schemas.Company[] | null;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>運送会社</BaseAccordionSummary>
      <AccordionDetails>
        <BaseFormLabel label="" isRequired sx={{ maxWidth: "376px" }}>
          <Controller
            name="companyId"
            control={control}
            render={({ field, fieldState }) => (
              <FormControl fullWidth error={fieldState.invalid} size="small">
                {companies === null ? (
                  <CircularProgress size={20} />
                ) : (
                  <Autocomplete
                    {...field}
                    value={
                      companies.find(
                        (company) => company.id.toString() === field.value,
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      field.onChange(newValue?.id.toString() || "");
                    }}
                    options={companies}
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id.toString() === value.id.toString()
                    }
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={fieldState.invalid}
                        placeholder="運送会社を選択してください"
                      />
                    )}
                  />
                )}
                {fieldState.error && (
                  <FormHelperText>{fieldState.error.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        </BaseFormLabel>
      </AccordionDetails>
    </BaseAccordion>
  );
};
